<template>
  <div class="adm-shell">
    <header class="adm-topbar">
      <div class="adm-topbar-left">
        <h1 v-if="title" class="adm-title">{{ title }}</h1>
        <slot name="status" />
      </div>
      <div v-if="$slots.actions" class="adm-topbar-right">
        <slot name="actions" />
      </div>
    </header>

    <nav v-if="tabs.length || $slots['nav-right'] || $slots['nav-left']" class="adm-nav">
      <div class="adm-nav-left">
        <slot name="nav-left" />
        <div v-if="tabs.length" class="adm-tabs">
          <button
            v-for="t in tabs"
            :key="t.key"
            type="button"
            class="adm-tab"
            :class="{ active: modelValue === t.key }"
            @click="$emit('update:modelValue', t.key)"
          >
            {{ t.label }}
          </button>
        </div>
      </div>
      <div v-if="$slots['nav-right']" class="adm-nav-right">
        <slot name="nav-right" />
      </div>
    </nav>

    <main class="adm-body" :class="{ 'adm-body--padded': padded }">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'AdminShell',
  props: {
    title: { type: String, default: '' },
    tabs: { type: Array, default: () => [] },
    modelValue: { type: String, default: '' },
    padded: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
}
</script>
